import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";

import {PhonePipe} from "./phone.pipe";
import { OrderByPipe } from "./order.pipe";
import { SafePipe } from "./safe.pipe";

@NgModule({
  declarations:[PhonePipe, OrderByPipe, SafePipe],
  imports:[CommonModule],
  exports:[PhonePipe, OrderByPipe, SafePipe]
})

export class MainPipe{}


// WEBPACK FOOTER //
// ./src/app/pipes/main-pipe.module.ts